<template>
  <div class="hotel-card px-4 mb-16 flex-initial" v-loading="isSaving">
    <router-link :to="goToHotel" target="_blank"
      class="hotel-card__link block rounded-sm overflow-hidden no-underline text-grey h-full bg-white">
      <div class="coverImage" v-lazy:background-image="coverExist ? hotelCover : require('@/assets/images/default-room.jpg')">
        <div v-if="Number(hotel.stars) > 0" class="rank-wrap flex items-center">
          <span class="bg-white rounded-full flex items-center">
            <i class="bg-orange rounded-full text-white owl-rank-star flex items-center justify-center" />
            <div class="text text-xs text-grey-darkest">{{ $t('unit.star', [$t('number')[Number(hotel.stars)]]) }}</div>
          </span>
        </div>
        <button v-show="isSavingBtn" class="btn-heart" @click.prevent="onFavoriteHandler(hotel)">
          <i
            :class="{ 'text-red': hotel.isFavorite }"
            class="owl-rank-heart"></i>
        </button>
      </div>
      <div class="hotelCard__content p-8">
        <h5 class="mb-4 text-grey-darkest font-bold" v-html="hotel.hotelName"></h5>
        <div v-if="hotel.hotelNameEn && selectedLang !== 'en'" class="text-sm mb-4 text-grey-darkest font-bold" v-html="hotel.hotelNameEn"></div>
        <div class="flex items-center mb-16">
          <span class="hotelCard__location">
            <!-- <i class="owl-location text-grey p-0 -ml-4" /> -->
            <span class="text-xs text-grey-dark">{{ hotel.countryText }} {{ hotel.cityText }}</span>
          </span>
          <div v-if="hotel.hotelType.name !== 'unknown'" class="text-xs text-grey-dark ml-4">| {{ hotel.hotelType.name }}</div>
        </div>
        <!-- <tripAdvisor></tripAdvisor> -->
        <div v-if="hotel.price && Number(hotel.price) > 0" class="flex items-center font-bold text-base" :class="{'mb-4': hotel.tags && hotel.tags.length > 0}">
          <div class="text-grey-darker">{{ currencySign }} {{ Number(hotel.price) | currencyConvert({inputCurrency: hotel.currency, listInteger: true}) }}</div>
          <i class="text-grey owl-caret-top" />
        </div>
        <div v-else class="flex items-center font-bold text-base" :class="{'mb-4': hotel.tags && hotel.tags.length > 0}">
          <div class="text-grey-darker">{{ $t('mapCard.priceBaseOnConditions') }}</div>
        </div>
        <div v-if="hotel.tags && hotel.tags.length > 0" class="flex flex-wrap justify-start items-center mt-4">
          <template v-for="tag in hotel.tags">
            <div :key="tag.id" class="text-xs py-4 rounded-sm os-tag os-tag-outline os-tag-grey" style="padding: 4px 6px">{{ tag.name || tag }}</div>
          </template>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import imgInfo from '@/utils/imgInfo'
// import tripAdvisor from '@/components/review/tripAdvisor'

export default {
  name: 'hotelCard',
  components: {
    // tripAdvisor
  },
  props: {
    hotel: {
      type: Object
    },
    isSavingBtn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isSaving: false,
      coverExist: false
    }
  },
  computed: {
    ...mapGetters({
      selectedLang: 'user/selectedLang',
      currencySign: 'user/currencySign',
      isLoadingFavorite: 'hotels/isLoadingFavorite'
    }),
    goToHotel: function () {
      return {
        name: 'HotelDetail',
        params: { hotelId: this.hotel.hotelUUID },
        query: {
          ...this.$route.query,
          search: this.hotel.hotelName,
          searchId: this.hotel.hotelUUID,
          searchType: 'hotel'
        }
      }
    },
    hotelCover: function () {
      if (Array.isArray(this.hotel.coverImage)) {
        return `${this.hotel.coverImage[0]}?width=700&format=jpeg`
      } else if (this.hotel.coverImage) {
        return `${this.hotel.coverImage}?width=700&format=jpeg`
      }
      return require('@/assets/images/default-room.jpg')
    }
  },
  methods: {
    onFavoriteHandler: function (hotel) {
      this.isSaving = true
      hotel.isFavorite ? this.$emit('removeFavorite', hotel) : this.$emit('addFavorite', hotel)
    }
  },
  async mounted () {
    let exist = false
    if (Array.isArray(this.hotel.coverImage)) {
      exist = await imgInfo.exist(this.hotel.coverImage[0])
    } else if (this.hotel.coverImage) {
      exist = await imgInfo.exist(this.hotel.coverImage)
    }
    this.coverExist = exist
  },
  watch: {
    isLoadingFavorite: function (val, oldVal) {
      if (!val && oldVal) {
        this.isSaving = false
      }
    }
  }
}
</script>

<style lang="sass">
.hotel-card
  &__link
    transition: .3s box-shadow
    &:hover
      @apply shadow-md
  .coverImage
    padding-top: imageRatio(324, 192)
    @apply bg-center bg-cover relative
    background-color: #f7f7f7
    .rank-wrap
      @apply absolute
      top: 6px
      left: 6px
      i
        padding: 4px
        margin: 2px 4px 2px 2px
        @apply text-sm
        &:before
          @apply mx-0
          margin-bottom: 1px
      .text
        margin:
          right: 6px
    .btn-heart
      @apply absolute text-white p-4 outline-none text-xl
      top: 0px
      right: 0px
      i.owl-rank-heart
        text-shadow: -1px 0 #eee, 0 1px #eee, 1px 0 #eee, 0 -1px #eee
        &:hover
          @apply text-red-light
  &__location
    @apply flex items-center
    i:before
      @apply ml-0
</style>
